/**
 * @generated SignedSource<<ad44e2fe416f78a15468374099a54d1f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type threePostMagSectionTopWidgetArticles$data = ReadonlyArray<{
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"postMagazineSectionWidgetThreeContent">;
  };
  readonly " $fragmentType": "threePostMagSectionTopWidgetArticles";
}>;
export type threePostMagSectionTopWidgetArticles$key = ReadonlyArray<{
  readonly " $data"?: threePostMagSectionTopWidgetArticles$data;
  readonly " $fragmentSpreads": FragmentRefs<"threePostMagSectionTopWidgetArticles">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "threePostMagSectionTopWidgetArticles",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "postMagazineSectionWidgetThreeContent"
            }
          ],
          "type": "Content",
          "abstractKey": "__isContent"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "QueueItemsEdge",
  "abstractKey": null
};

(node as any).hash = "6255e85e08a6133ecf6724b93c827c45";

export default node;
